// Gait analysis is edited/displayed as a fixed 5 x 8 grid (location x gait phase), addressed by index:
// index = locationIndex * 8 + typeIndex. Only cells with text are persisted; the grid is rebuilt here.
export const GAIT_LOCATIONS = ["ANKLE", "KNEE", "PELVIS_AND_HIPS", "ARMS", "UPPER_BACK_AND_SHOULDERS"];
export const GAIT_TYPES = ["HEEL_STRIKE", "FOOT_FLAT", "MID_STANCE", "HEEL_OFF", "TOE_OFF", "EARLY_SWING", "MID_SWING", "LATE_SWING"];

export const buildGaitGrid = (items) => {
    const grid = [];
    GAIT_LOCATIONS.forEach(gaitLocation => GAIT_TYPES.forEach(gaitType => grid.push({gaitLocation, gaitType, details: ""})));
    (items || []).forEach(item => {
        if (!item || !item.details) {
            return;
        }
        const locationIndex = GAIT_LOCATIONS.indexOf(item.gaitLocation);
        const typeIndex = GAIT_TYPES.indexOf(item.gaitType);
        if (locationIndex >= 0 && typeIndex >= 0) {
            grid[locationIndex * GAIT_TYPES.length + typeIndex].details = item.details;
        }
    });
    return grid;
};

export const compactGaitItems = (grid) =>
    (grid || [])
        .filter(cell => cell.details && cell.details.trim() !== "")
        .map(({gaitLocation, gaitType, details}) => ({gaitLocation, gaitType, details}));
